<div class="text"
     *iCms="'text' of component; content: 'html'; skipEmpty: true"></div>